/**
 * this file contains all redux-saga watchers & workers for the documents
 * - watchers watch for dispatched actions
 * - workers invoke another actions in response to the processed actions
 *
 * NOTE: Saga's use the new ES6 generator functions function* ()
 * NOTE: Arrow-function can not be used as generators as the yield keyword
 * may not work in an arrow function's body
 *
 * Created by Min on 21/08/18
 */

import { takeEvery, call, put, takeLatest } from 'redux-saga/effects'
import { delay } from 'redux-saga'

import C from '../constants'
import config from '../config'
import { request, isEmpty } from '../utility/utilities'

// import action creators
import * as DocumentsActions from '../actions/documentsActions'

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE DOC SIGN LINK
----------------------------------------------------------------------------- */

// watcher saga for fetching the doc sign link
export function* watchFetchDocSignStatus() {
    yield takeLatest(C.FETCH_DOC_SIGN_STATUS, workerFetchDocSignStatus)
}

// worker saga for fetching the the doc sign link
function* workerFetchDocSignStatus() {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = config.endpoints.doccumentStatusURL
    let data = false
    while (!data) { //if docusign is not ready try again in 10 second until is done

        try {
            // get the response promise object
            const response = yield call(request, requestURL, headers)
            if(!isEmpty(response.data)) {
                data = true
                // set the doc sign link
                yield put(DocumentsActions.setDocSignStatus(response.data))
            }

        } catch (error) {

            yield put(DocumentsActions.showDocumentsLoader(false))
            yield put(DocumentsActions.setDocumentsFetchSuccess(false))
            yield put(DocumentsActions.setDocSignStatus(false))
            yield delay(10000);

        } finally {
            yield put(DocumentsActions.showDocumentsLoader(false))
        }
    }
}

/* -----------------------------------------------------------------------------
    WATCHER & WORKER SAGA TO FETCH THE DOCUMENTS DATA
----------------------------------------------------------------------------- */

// watcher saga for fetching the doc sign link
export function* watchFetchDocumentsData() {
    yield takeEvery(C.FETCH_DOCUMNENTS_DATA, workerFetchDocumentsData)
}

// worker saga for fetching the the doc sign link
function* workerFetchDocumentsData() {
    // set the headers
    const headers = {
        method: 'GET',
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
        },
        mode: 'cors',
        cache: 'default'
    }

    // set the endpoint
    const requestURL = config.endpoints.documentsFetchURL
    let data = false

    while (!data) { //if docusign is not ready try again in 10 second until is done
        
        try {
            // show the loader
            yield put(DocumentsActions.showDocumentsLoader(true))

            // get the response promise object
            const response = yield call(request, requestURL, headers)

            if(!isEmpty(response.data)) {
                data = true
                // set the doc sign link
                yield put(DocumentsActions.setDocumentData(response.data))
            }

        } catch (error) {
            // set the success flag to false
            yield put(DocumentsActions.setDocumentsFetchSuccess(false))
            yield delay(10000);


        } finally {
            // hide the loader regardless
            yield put(DocumentsActions.showDocumentsLoader(false))
        }
    }
}



// WEBPACK FOOTER //
// ./src/sagas/documentsSaga.js